const TYPES = {
    GET_TAX_PROFILE: 'GET_TAX_PROFILE',
    GET_TAX_PROFILE_SUCCESS: 'GET_TAX_PROFILE_SUCCESS',
    GET_TAX_PROFILE_FAILED: 'GET_TAX_PROFILE_FAILED',
    UPDATE_TAX_PROFILE: 'UPDATE_TAX_PROFILE',
    UPDATE_TAX_PROFILE_SUCCESS: 'UPDATE_TAX_PROFILE_SUCCESS',
    UPDATE_TAX_PROFILE_FAILED: 'UPDATE_TAX_PROFILE_FAILED',
    PULL_TAX_PROFILE: 'PULL_TAX_PROFILE',
    PULL_TAX_PROFILE_SUCCESS: 'PULL_TAX_PROFILE_SUCCESS',
    PULL_TAX_PROFILE_FAILED: 'PULL_TAX_PROFILE_FAILED',
    FETCH_PROFILE_UPDATES: 'FETCH_PROFILE_UPDATES',
    GET_CONSENT_INTERVIEW: 'GET_CONSENT_INTERVIEW',
    GET_CONSENT_INTERVIEW_SUCCESS: 'GET_CONSENT_INTERVIEW_SUCCESS',
    GET_CONSENT_INTERVIEW_FAILED: 'GET_CONSENT_INTERVIEW_FAILED',
    GET_INTERVIEW: 'GET_INTERVIEW',
    GET_INTERVIEW_SUCCESS: 'GET_INTERVIEW_SUCCESS',
    GET_INTERVIEW_FAILED: 'GET_INTERVIEW_FAILED',
    SET_FORM: 'SET_FORM',
    TRACE_TAKE_INTERVIEW: 'TRACE_TAKE_INTERVIEW',
    GET_PAYOUT_ACCOUNT_STATUS: 'GET_PAYOUT_ACCOUNT_STATUS',
    GET_PAYOUT_ACCOUNT_STATUS_SUCCESS: 'GET_PAYOUT_ACCOUNT_STATUS_SUCCESS',
    GET_RETAKE_AVAILABLE: 'GET_RETAKE_AVAILABLE',
    GET_RETAKE_AVAILABLE_SUCCESS: 'GET_RETAKE_AVAILABLE_SUCCESS',
    GET_RETAKE_AVAILABLE_FAILED: 'GET_RETAKE_AVAILABLE_FAILED',
    RESET_INTERVIEW_CURRENT_URL: 'RESET_INTERVIEW_CURRENT_URL',
    RESET_INTERVIEW_FAILED: 'RESET_INTERVIEW_FAILED',
    GET_PAYOUT_ACCOUNT_STATUS_FAILED: 'GET_PAYOUT_ACCOUNT_STATUS_FAILED',
    GET_TAX_DOCUMENTS: 'GET_TAX_DOCUMENTS',
    GET_TAX_DOCUMENTS_SUCCESS: 'GET_TAX_DOCUMENTS_SUCCESS',
    SET_TAX_DOC_REQ_COUNT: 'SET_TAX_DOC_REQ_COUNT'
};

export default {
    TYPES,

    resetInterviewFailed: payload => {
        return {
            type: TYPES.RESET_INTERVIEW_FAILED
        };
    },

    getConsentTaxInterview: payload => {
        return {
            type: TYPES.GET_CONSENT_INTERVIEW,
            payload
        };
    },

    getConsentTaxInterviewSuccess: payload => {
        return {
            type: TYPES.GET_CONSENT_INTERVIEW_SUCCESS,
            payload
        };
    },

    getConsentTaxInterviewFailed: payload => {
        return {
            type: TYPES.GET_CONSENT_INTERVIEW_FAILED,
            payload
        };
    },

    getTaxRetakeAvailable: payload => {
        return {
            type: TYPES.GET_RETAKE_AVAILABLE,
            payload
        };
    },

    getTaxRetakeAvailableSuccess: resp => {
        return {
            type: TYPES.GET_RETAKE_AVAILABLE_SUCCESS,
            payload: resp
        };
    },

    getTaxRetakeAvailableFailed: (payload) => {
        return {
            type: TYPES.GET_RETAKE_AVAILABLE_FAILED,
            payload
        };
    },

    getTaxProfile: payload => {
        return {
            type: TYPES.GET_TAX_PROFILE,
            payload
        };
    },

    getTaxProfileSuccess: resp => {
        return {
            type: TYPES.GET_TAX_PROFILE_SUCCESS,
            payload: resp
        };
    },

    getTaxProfileFailed: (payload) => {
        return {
            type: TYPES.GET_TAX_PROFILE_FAILED,
            payload
        };
    },

    updateTaxProfile: payload => {
        return {
            type: TYPES.UPDATE_TAX_PROFILE,
            payload
        };
    },

    updateTaxProfileSuccess: resp => {
        return {
            type: TYPES.UPDATE_TAX_PROFILE_SUCCESS,
            payload: resp
        };
    },

    updateTaxProfileFailed: () => {
        return {
            type: TYPES.UPDATE_TAX_PROFILE_FAILED
        };
    },

    pullTaxProfile: () => {
        return {
            type: TYPES.PULL_TAX_PROFILE
        };
    },

    pullTaxProfileSuccess: () => {
        return {
            type: TYPES.PULL_TAX_PROFILE_SUCCESS
        };
    },

    pullTaxProfileFailed: () => {
        return {
            type: TYPES.PULL_TAX_PROFILE_FAILED
        };
    },

    fetchProfileUpdates: () => {
        return {
            type: TYPES.FETCH_PROFILE_UPDATES
        };
    },

    getInterview: (payload) => {
        return {
            type: TYPES.GET_INTERVIEW,
            payload
        };
    },

    getInterviewSuccess: (resp) => {
        return {
            type: TYPES.GET_INTERVIEW_SUCCESS,
            payload: resp
        };
    },

    getInterviewFailed: () => {
        return {
            type: TYPES.GET_INTERVIEW_FAILED
        };
    },

    getAccountStatus: () => {
        return {
            type: TYPES.GET_PAYOUT_ACCOUNT_STATUS
        };
    },

    getAccountStatusSuccess: (resp) => {
        return {
            type: TYPES.GET_PAYOUT_ACCOUNT_STATUS_SUCCESS,
            payload: resp
        };
    },

    getAccountStatusFailed: () => {
        return {
            type: TYPES.GET_PAYOUT_ACCOUNT_STATUS_FAILED
        };
    },

    traceTakeInterview: () => {
        return {
            type: TYPES.TRACE_TAKE_INTERVIEW
        };
    },

    setForm: payload => {
        return {
            type: TYPES.SET_FORM,
            payload
        };
    },

    resetInterviewCurrentUrl: payload => {
        return {
            type: TYPES.RESET_INTERVIEW_CURRENT_URL,
            payload
        };
    },

    getTaxDocuments: payload => {
        return {
            type: TYPES.GET_TAX_DOCUMENTS,
            payload
        };
    },

    getTaxDocumentsSuccess: payload => {
        return {
            type: TYPES.GET_TAX_DOCUMENTS_SUCCESS,
            payload
        };
    },

    setTaxDocReqCount: payload => {
        return {
            type: TYPES.SET_TAX_DOC_REQ_COUNT,
            payload
        };
    }
};
